import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { Options as OptionsType } from './types';

interface Props {
  dealType: string;
  options: OptionsType;
  stage: string;
  onDealTypeChange: (value: string) => void;
  onStageChange: (value: string) => void;
}

export function PreExtractionInputs({ dealType, options, stage, onDealTypeChange, onStageChange }: Props) {
  return (
    <div className="d-flex gap-2">
      <div>
        <ManagedFormGroup
          label="Deal Type"
          type="select"
          value={dealType}
          onValueChange={onDealTypeChange}
        >
          <Options options={[{ label: 'Detect with AI', value: '' }, ...options.dealType]} />
        </ManagedFormGroup>
      </div>

      <div>
        <ManagedFormGroup
          label="Stage"
          type="select"
          value={stage}
          onValueChange={onStageChange}
        >
          <Options options={[{ label: 'Detect with AI', value: '' }, ...options.stage]} />
        </ManagedFormGroup>
      </div>
    </div>
  );
}
